import { createFileRoute } from "@tanstack/react-router";
import { BnServiceDetail, bnServiceHead, type BnServiceContent } from "@/components/bn/BnServiceDetail";

const C: BnServiceContent = {
  path: "/bn/services/aeo",
  enPath: "/services/aeo",
  crumb: "AEO",
  title: "AEO সার্ভিস — ChatGPT, Perplexity ও Claude-এ উদ্ধৃত হোন",
  desc: "অ্যানসার ইঞ্জিন অপটিমাইজেশন (AEO) সার্ভিস। এন্টিটি এসইও, স্কিমা মার্কআপ ও উদ্ধৃতিযোগ্য কনটেন্টের মাধ্যমে ChatGPT, Perplexity, Claude ও Gemini-এর উত্তরে আপনার ব্র্যান্ডকে জায়গা করে দিই।",
  keywords: ["aeo service bangladesh", "AEO সার্ভিস", "অ্যানসার ইঞ্জিন অপটিমাইজেশন", "ChatGPT এসইও"],
  eyebrow: "অ্যানসার ইঞ্জিন অপটিমাইজেশন",
  h1: <>উদ্ধৃত হোন <span className="text-gradient">ChatGPT, Perplexity ও Claude-এ।</span></>,
  subtitle: "তথ্যভিত্তিক অনেক প্রশ্নের উত্তর এখন এআই সরাসরি দিয়ে দেয়, কেউ লিংকে ক্লিক করে না। AEO সেই উত্তরের ভেতরে আপনার নাম পৌঁছে দেওয়ার কাজ।",
  takeaways: [
    "AEO শুধু গুগল র‍্যাংকিং নয় — ChatGPT, Perplexity, Claude ও Gemini-এর উত্তরে আপনার ব্র্যান্ডের উদ্ধৃতি এনে দেয়।",
    "এর ভিত্তি তিনটি: এন্টিটি অথরিটি, ছোট ও উদ্ধৃতিযোগ্য উত্তর-ব্লক, আর সঠিক স্কিমা (FAQPage, Article, sameAs সহ Organization)।",
    "যারা AEO উপেক্ষা করে, তারা গুগলে র‍্যাংক করলেও প্রতি মাসে এআই সার্চে জায়গা হারায়।",
  ],
  programTitle: "AEO প্রোগ্রাম",
  programDesc: "৯০ দিনের একটি স্প্রিন্ট, যার শেষে আপনার সাইট এমন উৎসে পরিণত হয় যাকে এআই অ্যাসিস্ট্যান্ট উদ্ধৃত করে।",
  price: "AEO স্প্রিন্ট: ২৫,০০০–৬০,০০০ টাকা (৬–৮ সপ্তাহ)",
  cta: "AEO নিয়ে কথা বলুন",
  deliverables: [
    "এন্টিটি ও ব্র্যান্ড নলেজ গ্রাফ তৈরি",
    "উদ্ধৃতিযোগ্য কনটেন্ট রিরাইট (৪০–৬০ শব্দের উত্তর-ব্লক)",
    "sameAs সহ FAQPage, Article ও Organization স্কিমা",
    "ChatGPT, Perplexity, Claude ও Gemini-তে এআই ভিজিবিলিটি ট্র্যাকিং",
    "llms.txt ও এআই ক্রলার অ্যাক্সেস নীতি",
    "মাসিক উদ্ধৃতি ও শেয়ার-অফ-ভয়েস রিপোর্ট",
  ],
  outcomes: ["ChatGPT ও Perplexity-তে উদ্ধৃতি", "এআই উত্তরে ব্র্যান্ডের উল্লেখ", "এআই সার্চে টেকসই অবস্থান"],
  faqs: [
    { q: "অ্যানসার ইঞ্জিন অপটিমাইজেশন (AEO) কী?", a: "AEO হলো কনটেন্ট, স্কিমা ও এন্টিটি সিগন্যাল এমনভাবে সাজানো, যাতে ChatGPT, Perplexity, Claude ও Gemini-এর মতো এআই উত্তর-ইঞ্জিন তাদের উত্তরে সরাসরি আপনার ব্র্যান্ডকে উদ্ধৃত করে।" },
    { q: "AEO আর এসইও-র পার্থক্য কী?", a: "এসইও নীল লিংকের তালিকায় পেজ র‍্যাংক করায়। AEO সেই লিংকগুলোর ওপরে (বা তাদের বদলে) এআই-তৈরি উত্তরের ভেতরে উদ্ধৃতি এনে দেয়। AEO-তে এন্টিটি, স্ট্রাকচার্ড ডেটা ও ছোট উদ্ধৃতিযোগ্য উত্তরের গুরুত্ব বেশি।" },
    { q: "ChatGPT বা Perplexity-তে কীভাবে উদ্ধৃত হব?", a: "স্পষ্ট এন্টিটি সম্পর্ক তৈরি করুন, নিজস্ব ডেটা ও গবেষণা প্রকাশ করুন, উত্তর ৪০–৬০ শব্দের অনুচ্ছেদে লিখুন, FAQ ও Article স্কিমা ব্যবহার করুন, এবং এই মডেলগুলো যেসব উৎসে ভরসা করে সেখানে উল্লেখ অর্জন করুন।" },
    { q: "কতদিনে এআই উদ্ধৃতি পাওয়া শুরু হয়?", a: "এন্টিটি, স্কিমা ও কনটেন্টের কাজ শেষ হওয়ার পর বেশিরভাগ ক্ষেত্রে ৩–৬ সপ্তাহের মধ্যে প্রথম ChatGPT বা Perplexity উদ্ধৃতি দেখা যায়।" },
  ],
  serviceName: "অ্যানসার ইঞ্জিন অপটিমাইজেশন (AEO)",
  serviceType: "Answer Engine Optimization",
  related: [
    { to: "/bn/services/geo", label: "GEO প্রোগ্রাম দেখুন" },
    { to: "/bn/services/seo", label: "এসইও সার্ভিস" },
  ],
};

export const Route = createFileRoute("/bn/services/aeo")({
  head: () => bnServiceHead(C),
  component: () => <BnServiceDetail c={C} />,
});
